'use client'

import type { PreviewProviderProps } from '@maestro/sanity/components/preview-provider/preview-provider.types'

import { createClient } from '@sanity/client'
import { LiveQueryProvider } from '@sanity/preview-kit'

export function PreviewProvider({ children, config }: PreviewProviderProps) {
  const client = createClient(config)
  const token = config.token
  if (!token) {
    throw new TypeError('Missing token for preview')
  }

  return (
    <LiveQueryProvider client={client} token={token} logger={console}>
      {children}
    </LiveQueryProvider>
  )
}
